import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M8.7 4l-3-2a.5.5 0 00-.5 0l-3 2a.5.5 0 00-.2.5v5a.5.5 0 00.5.5h2V6.5h2V10h2a.5.5 0 00.5-.5v-5a.5.5 0 00-.3-.5zM8.7 14l-3-2a.5.5 0 00-.5 0l-3 2a.5.5 0 00-.3.5v5a.5.5 0 00.6.5h2v-3.5h2V20h2a.5.5 0 00.4-.5v-5a.5.5 0 00-.2-.4zM8.7 24l-3-2a.5.5 0 00-.5 0l-3 2a.5.5 0 00-.3.5v5a.5.5 0 00.6.5h2v-3.5h2V30h2a.5.5 0 00.4-.5v-5a.5.5 0 00-.2-.4z"/><rect x="13" y="5" width="17" height="4" rx="2"/><rect x="13" y="14" width="17" height="4" rx="2"/><rect x="13" y="23" width="17" height="4" rx="2"/>';
export var MLSSVG = function MLSSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
MLSSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(MLSSVG);